<template>
  <div>
    <div class="d-flex">
      <div v-if="items" class="mt-4 mr-8">
        <p-icon
          :icon="collapse ? 'minus' : 'plus'"
          color="fg-primary"
          class="d-flex place-items-center"
          :style="{
            'font-size': (collapse ? 3 : 16) + 'px',
            height: '32px',
            width: '32px',
          }"
          @click="collapse = !collapse"
        />
      </div>
      <div class="flex-grow-1 mt-8">
        <div
          class="d-flex justify-content-between align-items-center"
          @click="collapse = !collapse"
        >
          <div class="f-utility-16-normal t-fg-primary">
            {{ name }}
          </div>
          <div :class="`f-utility-16-normal t-fg-${color}`">
            {{ status }}
          </div>
        </div>
        <div v-if="items" v-show="collapse" class="py-32">
          <div v-for="(item, index) in items" :key="`statusItemKey--${index}`">
            <div class="d-flex justify-content-between align-items-center">
              <div class="f-utility-16-normal t-fg-primary">
                {{ item.name }}
              </div>
              <div :class="`f-utility-16-normal t-fg-${item.color || 'accent'}`">
                {{ item.status }}
              </div>
            </div>
            <p-divider v-if="index < items.length - 1" class="my-12" />
          </div>
        </div>
      </div>
    </div>
    <p-divider v-if="divider" class="my-24" />
    <div v-else class="my-24"></div>
  </div>
</template>

<script setup lang="ts">
interface Item {
  name: string
  status: string
  color?: string
}

defineProps({
  name: {
    type: String,
    required: true,
  },
  status: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'accent',
    validator: (val: string) => ['accent', 'warning', 'blue', 'danger'].includes(val),
  },
  items: {
    type: Array as () => Item[],
    default: () => [],
  },
  divider: {
    type: Boolean,
    default: true,
  },
})

const collapse = ref(false)
</script>
